import type { FnsLocale } from 'shared/types';

export const FALLBACK_LNG: FnsLocale = 'en-GB';
